import { Component, OnInit, NgZone } from "@angular/core";
import { TalentService } from "../talent.service";
import { Sort } from "@angular/material/sort";
import { ActiveCandidatesFilter } from "../custom.pipe";
import ChartDataLabels from "chartjs-plugin-datalabels"
import type { ChartEvent, ActiveElement, Chart } from 'chart.js';


@Component({
    selector: "app-daily-candidate-summary",
    templateUrl: "./daily-candidate-summary.component.html",
    styleUrls: ["./daily-candidate-summary.component.css"],
    providers: [ActiveCandidatesFilter],
    standalone: false
})
export class DailyCandidateSummaryComponent implements OnInit {
  showDisplayCandidates: boolean = false;
  showRolesPipeline: boolean = false;
  dcs_pending_test_submission = [];
  dcs_pending_scheduling = [];
  dcs_phone_interviews = [];
  dcs_inhouse_interviews = [];
  dcs_awaiting_feedback = [];
  dcs_selected = [];
  dcs_prospect = [];
  dcs_left_message = [];
  rps_prospect = [];
  rps_resume_submitted = [];
  rps_phone_interview = [];
  rps_inhouse_interview = [];
  rps_awaiting_feedback = [];
  rps_pending_scheduling = [];
  rps_closed = [];
  rps_start_date = [];
  rps_role_id: string = '';
  rps = [];
  rps_reset = [];
  showGraph = 0;
  showRPSGraph = 0;
  pieChartLabels;
  pieChartData;
  pieChartType;
  pieChartOptions;
  pieChartLegend;
  pieChartColors;
  barChartOptions;
  barChartTotals: any = [];
  barChartColors;
  barChartLabels: string[] = [''];
  show_pending_test_submission = false;
  show_pending_scheduling = false;
  show_phone_interviews = false;
  show_inhouse_interviews = false;
  show_awaiting_feedback = false;
  show_selected = true;
  show_prospect = false;
  show_left_message = false;
  roles;
  rolesObj = {};
  role_title;
  client;
  user_drop_down_data = [];
  nameId_DCS;
  nameId_RPS;
  myActiveCandidates: any = [];
  showRoles: any = [];
  sortedRoles: any = [];
  allRoles: any = [];
  show_detail: Object = {};
  show_role_candidates: Object = {};
  currentSort: Sort = { active: "days_since_open", direction: "asc" };
  showActivePipelines: boolean = true;
  showOpenRoles: boolean = true;
  page: number = 1;
  rowsPerPage: number = 100;
  sortType: string = "practice_group"
  sortReverse: boolean = false;
  dateFilterStart;
  dateFilterEnd;
  totalsList;
  contractChecked = true;
  permanentChecked = true;
  userWorkflow = [];
  roleFilter: string;
  roleCandidatesInitialFilter: string = undefined;
  pipelineCategories = [
    // {name:"Prospect",color:"#4CAF50"},
    { name: "Urgent Prospect", color: "#00acc1" },
    { name: "Recruiter Screen", color: "#808080" },
    { name: "Resume Submitted", color: "#424242" },
    { name: "First Interview", color: "#795548" },
    { name: "Second Interview", color: "#ff781e" },
    { name: "Additional Interview", color: "#fa4b74" },
    { name: "Selected", color: "#43719E" },
    { name: "Started", color: "#FFC107" }
  ];

  startTime: any = new Date();
  endTime: any;

  public barChartPlugins = [ChartDataLabels]
  public pieChartPlugins = [ChartDataLabels]

  private chartClicked(chart: Chart, element: any[]): void {

    if (element.length > 0) {
      // get the internal index of slice in pie chart
      const clickedElementIndex = element[0].index;
      const label = chart.data.labels[clickedElementIndex];
      if (label == "Pending Test Submission") {
        this.show_pending_test_submission = true;
        this.show_pending_scheduling = false;
        this.show_phone_interviews = false;
        this.show_inhouse_interviews = false;
        this.show_awaiting_feedback = false;
        this.show_selected = false;
        this.show_prospect = false;
        this.show_left_message = false;
      } else if (label == "Pending Scheduling") {
        this.show_pending_scheduling = true;
        this.show_pending_test_submission = false;
        this.show_phone_interviews = false;
        this.show_inhouse_interviews = false;
        this.show_awaiting_feedback = false;
        this.show_selected = false;
        this.show_prospect = false;
        this.show_left_message = false;
      } else if (label == "Phone Interview") {
        this.show_phone_interviews = true;
        this.show_pending_test_submission = false;
        this.show_pending_scheduling = false;
        this.show_inhouse_interviews = false;
        this.show_awaiting_feedback = false;
        this.show_selected = false;
        this.show_prospect = false;
        this.show_left_message = false;
      } else if (label == "InHouse Interview") {
        this.show_inhouse_interviews = true;
        this.show_pending_test_submission = false;
        this.show_pending_scheduling = false;
        this.show_phone_interviews = false;
        this.show_awaiting_feedback = false;
        this.show_selected = false;
        this.show_prospect = false;
        this.show_left_message = false;
      } else if (label == "Awaiting Feedback") {
        this.show_awaiting_feedback = true;
        this.show_pending_test_submission = false;
        this.show_pending_scheduling = false;
        this.show_phone_interviews = false;
        this.show_inhouse_interviews = false;
        this.show_selected = false;
        this.show_prospect = false;
        this.show_left_message = false;
      } else if (label == "Selected") {
        this.show_selected = true;
        this.show_pending_test_submission = false;
        this.show_pending_scheduling = false;
        this.show_phone_interviews = false;
        this.show_inhouse_interviews = false;
        this.show_awaiting_feedback = false;
        this.show_prospect = false;
        this.show_left_message = false;
      } else if (label == "Prospect") {
        this.show_selected = false;
        this.show_pending_test_submission = false;
        this.show_pending_scheduling = false;
        this.show_phone_interviews = false;
        this.show_inhouse_interviews = false;
        this.show_awaiting_feedback = false;
        this.show_prospect = true;
        this.show_left_message = false;
      } else if (label == "Left Message") {
        this.show_selected = false;
        this.show_pending_test_submission = false;
        this.show_pending_scheduling = false;
        this.show_phone_interviews = false;
        this.show_inhouse_interviews = false;
        this.show_awaiting_feedback = false;
        this.show_prospect = false;
        this.show_left_message = true;
      }
    }
  }

  public chartHovered(e: any): void {}

  constructor(
    private talentService: TalentService,
    private filterPipe: ActiveCandidatesFilter,
    private NgZone: NgZone
  ) {}

  ngOnInit() {

  const outer_this = this;

  this.barChartOptions = {
    onClick: function (event, element) {

      outer_this.NgZone.run(() => 
      {
        if (element.length) {
          outer_this.toggle_show_role_candidates(
            event.chart.data.datasets[0].role_id,
            element[0].datasetIndex
          );
        } else {
          outer_this.toggle_show_role_candidates(
            event.chart.data.datasets[0].role_id
          );
        }})
},
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },

    scales: {
      xAxes: [{
        stacked: true,
        display: false,
        gridLines: { display: false, drawBorder: false },
        ticks: { beginAtZero: true, stepSize: 1 }
      }],
      yAxes: [{
        stacked: true,
        display: false,
        gridLines: { display: false, drawBorder: false }
      }]
    },

    tooltips: {
      enabled: true,
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          const ds: any = data.datasets[tooltipItem.datasetIndex];
          const total = ds.total ?? 0;
          const current = ds.summary ?? 0;
          const value = tooltipItem.xLabel ?? 0;

          // Example: "Recruiter Screen: 6 | Current 2"
          return `${ds.label}: ${value} | Current ${current}` + (total ? ` (Total ${total})` : '');
        }
      }
    },

    plugins: {
      datalabels: {
        color: '#ffffff',
        anchor: "center",
        align: "center",
        clamp: true,

        display: function (context) {
          const v = context.dataset.data?.[context.dataIndex] ?? 0
          return v > 0
        },

        font: { weight: 'bold', size: 11 },
        formatter: function (value: any, context: any) {
          const ds: any = context.dataset;
          const current = ds.summary ?? 0;
          const v = Array.isArray(value) ? value[0] : value;
          if (!v) return '';
          return `${v} | ${current}`;
        }
      }
    },
  };


    this.talentService.getYodaweUsersData().subscribe((yodawe_users) => {
      this.user_drop_down_data = yodawe_users;

      this.nameId_RPS = 999;
      if (this.nameId_RPS == 1 || this.nameId_RPS == 22) {
        this.nameId_RPS = 999;
      }
      if (this.nameId_DCS == 1) {
        this.nameId_DCS = 999;
      }

    });
    this.startTime = new Date();

    this.talentService.getUserWorkflow().subscribe((workflow) => {
      this.userWorkflow = workflow;
      this.endTime = new Date();
      console.log("Loading workflow", this.startTime - this.endTime);
      this.displayRolesPipeline();
      this.rolesPipeline();
    });
  }

  getDailyCandidateData() {
    this.talentService.getWorkflowTotals().subscribe((totals) => {
      this.barChartTotals = totals;
    });
  }

  displayDailyCandidate() {
    this.getDailyCandidateData();
    this.dailyCandidate();
    this.showRolesPipeline = false;
    this.showDisplayCandidates = true;
  }

  displayRolesPipeline() {
    this.showDisplayCandidates = false;
    this.showRolesPipeline = true;
  }

  dailyCandidate() {
    let startTime2: any = new Date();
    const outer_this = this
    this.talentService.getOpenRolesNew("all").subscribe((roles) => {
      this.roles = roles;
      for (let i of this.roles) {
        this.rolesObj[i["role_id"]] = i["title"];
      }

      this.talentService.getMyActiveCandidates().subscribe((resp) => {
        this.myActiveCandidates = Array.from(resp);
        this.filterDCSummary(resp);

        this.pieChartData = {

              labels: [
              "Pending Scheduling",
              "Phone Interview",
              "InHouse Interview",
              "Pending Test Submission",
              "Awaiting Feedback",
              "Selected",
              "Prospect",
              "Left Message",
              ],

              
              
              datasets: [
              {
                data:
                  [
                  this.dcs_pending_scheduling.length,
                  this.dcs_phone_interviews.length,
                  this.dcs_inhouse_interviews.length,
                  this.dcs_pending_test_submission.length,
                  this.dcs_awaiting_feedback.length,
                  this.dcs_selected.length,
                  this.dcs_prospect.length,
                  this.dcs_left_message.length
                  ],
                  backgroundColor:
                    [
                      "#ff781e",
                      "#FF6600",
                      "#db5902",
                      "#43719e",
                      "#1f66ad",
                      "#0050a0",
                      "lightgray",
                      "gray",
                    ],
                  borderWidth: 0.2
              }]};
        this.showGraph = 1;
        this.pieChartLabels = [
          "Pending Scheduling",
          "Phone Interview",
          "InHouse Interview",
          "Pending Test Submission",
          "Awaiting Feedback",
          "Selected",
          "Prospect",
          "Left Message",
        ];
        this.pieChartType = "pie";
        this.pieChartOptions = {
          responsive: true,
          maintainAspectRatio: false,

          onClick: function (event, element) {
            if (!element || !element.length) return;

            const sliceIndex = element[0].index;
            const labels = event.chart?.data?.labels as string[];
            if (!labels || typeof sliceIndex !== 'number') return;

            const label = labels[sliceIndex];
            if (!label) return;

            outer_this.NgZone.run(() => {
              outer_this.applyDailyCandidateFilter(label as string);
            });
          },

          plugins: {

            legend: {
              display: true,
              position: 'left',
              align: 'start',
              labels: {
                boxWidth: 12,
              }
            },

            datalabels: {
              color: '#ffffff',
              font: {
                size: 17
              },

              "align": "end",        // Aligns label toward the outside
              "offset": 15,           // Distance from the arc edge
              formatter: (value: any) => {
                const v = typeof value === 'number' ? value : Number(value);

                return v > 0 ? v : '';
              }
            },

            tooltip: {
              callbacks: {
                label: (context: any) => {
                  const value = context.parsed ?? 0;
                  return `${value}`;
                }
              }
            }
          }
        };
        this.pieChartLegend = true;
        this.pieChartColors = [
          {
            backgroundColor: [
              "#ff781e",
              "#FF6600",
              "#db5902",
              "#43719e",
              "#1f66ad",
              "#0050a0",
              "lightgray",
              "gray",
            ],
          },
        ];
        // this.pieChartColors = [{backgroundColor: ["#00b2ff", "#00ffcb", "#00ff3f",'#b2ff00', "#FF6600", "#ff00aa"]}];
      });
      let endTime2: any = new Date();
      console.log("Get Daily Candidate", endTime2 - startTime2);
    });
  }

  rolesPipeline() {
    let startTime3: any = new Date();
    let loadAllRoles = "open";
    if (!this.showOpenRoles) {
      loadAllRoles = "all";
    }
    this.talentService
      .getRolesPipelineSummary(loadAllRoles)
      .subscribe((resp) => {
        this.allRoles = Array.from(resp["roles"]);
        this.allRoles = this.allRoles.map((role) => {
          {
            let usermap = [];
            this.userWorkflow.map((entry) => {
              if (entry.role_id == role.role_id) {
                usermap.push({
                  id: entry.user_id,
                  last_update: entry.last_update,
                });
              }
            });
            return { ...role, user: usermap };
          }
        });

        if (this.nameId_RPS !== 999) {
          this.showRoles = this.allRoles.filter((n) => {
            return n.users.includes(this.nameId_RPS);
          });
        } else {
          this.showRoles = this.allRoles;
        }
        if (this.showOpenRoles) {
          this.showRoles = this.showRoles.filter((n) => n.open);
        }
        if (this.showActivePipelines) {
          this.showRoles = this.showRoles.map((n) => {
            return {
              ...n,
              show_pipelines: n.total_pipelines,
              show_pipeline_summary: n.active_pipeline_summary,
            };
          });
        } else {
          this.showRoles = this.showRoles.map((n) => {
            return {
              ...n,
              show_pipelines: n.total_pipelines,
              show_pipeline_summary: n.pipeline_summary,
            };
          });
        }
        // this.sortedRoles = this.showRoles.slice();
        this.sortRoles();

        var outer_this = this;

        this.barChartOptions = {
          onClick: function (event, element) {

            outer_this.NgZone.run(() => {

  if (element.length) {
    outer_this.toggle_show_role_candidates(
      event.chart.data.datasets[0].role_id,
      element[0].datasetIndex
    );
  } else {
    outer_this.toggle_show_role_candidates(
      event.chart.data.datasets[0].role_id
    );
  }})
},
          responsive: true,
          indexAxis: 'y',
          maintainAspectRatio: true,
          scales: {
                x: {
                  display: false,
                  stacked: true,
                  grid: {
                    drawBorder: false,
                    display: false
                  },
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    autoSkip: false,
                    stepSize: 1
                  }
                },
                y: {
                  stacked: true,
                  grid: {
                    drawBorder: false,
                    display: false
                  }
                }
              },
          plugins: {
            datalabels: {
              color: "white",

              // color: function(context) {
              //   var color = context.dataset.backgroundColor;
              //   return (parseInt(color.substring(1,3), 16) * 0.299 + parseInt(color.substring(3,5), 16) * 0.587 + parseInt(color.substring(5,7), 16) *0.114) > 155 ? 'black':'white'
              // },
              display: function (context) {
                return (
                  (context.dataset.data[context.dataIndex] /
                    context.dataset.total) *
                    100 >
                  5
                );
              },
              font: {
                weight: "bold",
                size: 10,
              },
              formatter: function (value, context) {
                if (value !== 0) {
                  if (context.dataset.label == "Recruiter Screen") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "Resume Submitted") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "First Interview") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "Second Interview") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "Additional Interview") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "Selected") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "Started") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "Prospect") {
                    return value + " | " + context.dataset.summary;
                  } else if (context.dataset.label == "Urgent Prospect") {
                    return value + " | " + context.dataset.summary;
                  } else {
                    return value;
                  }
                } else {
                  return "";
                }
              },
            },
            tooltip: {
              mode: 'nearest',
              intersect: true,
              callbacks: {
                title: function () { return ''; },
                label: function (tooltipItem) {
                  const ds = tooltipItem.dataset as any;
                  if (ds.label === 'Reset') return '';
                  const value = tooltipItem.parsed.x ?? 0;
                  const summary = ds.summary ?? 0;
                  return `${ds.label}: ${value} | Current ${summary}`;
                }
              }
            },
            legend: {
              display: false,
            },
          },
        };
        this.showRPSGraph = 1;
        this.barChartColors = [
          { backgroundColor: "#00acc1" },
          { backgroundColor: "#808080" },
          { backgroundColor: "#424242" },
          { backgroundColor: "#795548" },
          { backgroundColor: "#ff781e" },
          { backgroundColor: "#fa4b74" },
          { backgroundColor: "#43719E" },
          { backgroundColor: "#FFC107" },
        ];

        let endTime3: any = new Date();
        console.log("Loading Roles Pipelines ", endTime3 - startTime3);
      });
  }

  selectUserDCS() {
    const outer_this = this
    this.dcs_pending_test_submission = [];
    this.dcs_pending_scheduling = [];
    this.dcs_phone_interviews = [];
    this.dcs_inhouse_interviews = [];
    this.dcs_awaiting_feedback = [];
    this.dcs_selected = [];
    this.dcs_prospect = [];
    this.dcs_left_message = [];
    this.filterDCSummary(this.myActiveCandidates);
    this.pieChartData = {

      labels: [
      "Pending Scheduling",
      "Phone Interview",
      "InHouse Interview",
      "Pending Test Submission",
      "Awaiting Feedback",
      "Selected",
      "Prospect",
      "Left Message",
      ],
      
      datasets: [
      {
        data:
          [
          this.dcs_pending_scheduling.length,
          this.dcs_phone_interviews.length,
          this.dcs_inhouse_interviews.length,
          this.dcs_pending_test_submission.length,
          this.dcs_awaiting_feedback.length,
          this.dcs_selected.length,
          this.dcs_prospect.length,
          this.dcs_left_message.length
          ],
          backgroundColor:
            [
              "#ff781e",
              "#FF6600",
              "#db5902",
              "#43719e",
              "#1f66ad",
              "#0050a0",
              "lightgray",
              "gray",
            ],
          borderWidth: 0.2
      }]};
    this.showGraph = 1;
    this.pieChartLabels = [
      "Pending Scheduling",
      "Phone Interview",
      "InHouse Interview",
      "Pending Test Submission",
      "Awaiting Feedback",
      "Selected",
      "Prospect",
      "Left Message",
    ];
    this.pieChartType = "pie";
    this.pieChartOptions = {
        responsive: true,
        maintainAspectRatio: false,

        onClick: function (event, element) {
          
          if (!element || !element.length) return;

          const sliceIndex = element[0].index;
          const labels = event.chart?.data?.labels as string[];
          if (!labels || typeof sliceIndex !== 'number') return;

          const label = labels[sliceIndex];
          if (!label) return;

          outer_this.NgZone.run(() => {
            outer_this.applyDailyCandidateFilter(label as string);
          });
        },

        plugins: {
          legend: {
            display: true,
            position: 'left',
            align: 'start',
            labels: {
              usePointStyle: true,
              pointStyle: "rect",
              pointStyleWidth: 28
            }
          },
          datalabels: {
            color: '#ffffff',
            font: { size: 17 },
            align: "end",
            offset: 15,
            formatter: (value: any) => {
              const v = typeof value === 'number' ? value : Number(value);
              return v > 0 ? v : '';
            }
          },
          tooltip: {
            callbacks: {
              label: (context: any) => {
                const value = context.parsed ?? 0;
                return `${value}`;
              }
            }
          }
        }
      };
    this.pieChartLegend = true;
    this.pieChartColors = [
      {
        backgroundColor: [
          "#ff781e",
          "#FF6600",
          "#db5902",
          "#43719e",
          "#1f66ad",
          "#0050a0",
          "lightgray",
          "gray",
        ],
      },
    ];
    // this.pieChartColors = [{backgroundColor: ["#00b2ff", "#00ffcb", "#00ff3f",'#b2ff00', "#FF6600", "#ff00aa"]}];
  }

  toggleOpenRoles() {
    if (!this.showOpenRoles) {
      this.rolesPipeline();
    }
  }

  updateRolesPipelineTable() {
    if (this.nameId_RPS !== 999) {
      this.showRoles = this.allRoles.filter((n) => {
        return n.user.some((n) => {
          return n.id == this.nameId_RPS;
        });
      });
    } else {
      this.showRoles = this.allRoles;
    }
    if (this.showOpenRoles) {
      this.showRoles = this.showRoles.filter((n) => n.open);
    }
    if (this.showActivePipelines) {
      this.showRoles = this.showRoles.map((n) => {
        return {
          ...n,
          show_pipelines: n.total_pipelines,
          show_pipeline_summary: n.active_pipeline_summary,
        };
      });
    } else {
      this.showRoles = this.showRoles.map((n) => {
        return {
          ...n,
          show_pipelines: n.total_pipelines,
          show_pipeline_summary: n.pipeline_summary,
        };
      });
    }
    if (this.dateFilterStart && this.nameId_RPS !== 999) {
      this.showRoles = this.showRoles.filter((role) => {
        return (
          role.user.filter((n) => {
            let d1 = new Date(n.last_update).toISOString().slice(0, 10);
            let d2 = new Date(this.dateFilterStart).toISOString().slice(0, 10);
            return d1 >= d2 && n.id == this.nameId_RPS;
          }).length > 0
        );
      });
    }
    if (this.dateFilterEnd && this.nameId_RPS !== 999) {
      this.showRoles = this.showRoles.filter((role) => {
        return (
          role.user.filter((n) => {
            let d1 = new Date(n.last_update).toISOString().slice(0, 10);
            let d2 = new Date(this.dateFilterEnd).toISOString().slice(0, 10);
            return d1 <= d2 && n.id == this.nameId_RPS;
          }).length > 0
        );
      });
    }
    if (this.contractChecked && this.permanentChecked) {
      this.showRoles = this.showRoles;
    } else if (this.contractChecked) {
      this.showRoles = this.showRoles.filter((role) => {
        return role.type_string == "Contract";
      });
    } else if (this.permanentChecked) {
      this.showRoles = this.showRoles.filter((role) => {
        return role.type_string == "Permanent";
      });
    } else {
      this.showRoles = [];
    }

    this.showRoles = this.filterPipe.transform(this.showRoles, this.roleFilter);

    this.sortRoles();
    this.updateBarChart();
  }
  updateBarChart() {
    const outer_this = this
    this.barChartOptions = {
      onClick: function (event, element) {

        outer_this.NgZone.run(() => {

  if (element.length) {
    outer_this.toggle_show_role_candidates(
      event.chart.data.datasets[0].role_id,
      element[0].datasetIndex
    );
  } else {
    outer_this.toggle_show_role_candidates(
      event.chart.data.datasets[0].role_id
    );
  }})
},
          responsive: true,
          indexAxis: 'y',
          maintainAspectRatio: true,
          scales: {
                x: {
                  display: false,
                  stacked: true,
                  grid: {
                    drawBorder: false,
                    display: false
                  },
                  ticks: {
                    display: false,
                    beginAtZero: true,
                    autoSkip: false,
                    stepSize: 1
                  }
                },
                y: {
                  stacked: true,
                  grid: {
                    drawBorder: false,
                    display: false
                  }
                }
              },

      plugins: {
        datalabels: {
          color: "white",
          // color: function(context) {
          //   var color = context.dataset.backgroundColor;
          //   return (parseInt(color.substring(1,3), 16) * 0.299 + parseInt(color.substring(3,5), 16) * 0.587 + parseInt(color.substring(5,7), 16) *0.114) > 155 ? 'black':'white'
          // },
          display: function (context) {
            return (
              (context.dataset.data[context.dataIndex] /
                context.dataset.total) *
                100 >
              5
            );
          },
          font: {
            weight: "bold",
            size: 10,
          },
          formatter: function (value, context) {
            if (value !== 0) {
              if (context.dataset.label == "Recruiter Screen") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "Resume Submitted") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "First Interview") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "Second Interview") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "Additional Interview") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "Selected") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "Started") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "Prospect") {
                return value + " | " + context.dataset.summary;
              } else if (context.dataset.label == "Urgent Prospect") {
                return value + " | " + context.dataset.summary;
              } else {
                return value;
              }
            } else {
              return "";
            }
          },
        },
        tooltip: {
          mode: 'nearest',
          intersect: true,
          callbacks: {
            title: function () { return ''; },
            label: function (tooltipItem) {
              const ds = tooltipItem.dataset as any;
              if (ds.label === 'Reset') return '';
              const value = tooltipItem.parsed.x ?? 0;
              const summary = ds.summary ?? 0;
              return `${ds.label}: ${value} | Current ${summary}`;
            }
          }
        },

      legend: {
        display: false,
      }
      },
    };
  }

  private applyDailyCandidateFilter(label: string): void {
    this.show_pending_test_submission = label === "Pending Test Submission";
    this.show_pending_scheduling = label === "Pending Scheduling";
    this.show_phone_interviews = label === "Phone Interview";
    this.show_inhouse_interviews = label === "InHouse Interview" || label === "In-house Interview";
    this.show_awaiting_feedback = label === "Awaiting Feedback";
    this.show_selected = label === "Selected";
    this.show_prospect = label === "Prospect";
    this.show_left_message = label === "Left Message";
  }

  public onDailyPieClick(
    e: { event?: ChartEvent; active?: ActiveElement[] | any[] }
  ): void {
    const active = (e?.active ?? []) as any[];
    if (!active.length) return;

    const sliceIndex = active[0]?.index;
    if (typeof sliceIndex !== 'number') return;

    // Works whether you store labels in pieChartData.labels or pieChartLabels
    const labels =
      (this.pieChartData?.labels as string[] | undefined) ??
      (this.pieChartLabels as string[] | undefined) ??
      [];

    const label = labels[sliceIndex];
    if (!label) return;

    this.applyDailyCandidateFilter(label);
  }



  filterDCSummary(candidate_list) {
    for (let x of candidate_list) {
      if (this.nameId_DCS != 999 || this.nameId_DCS == 1) {
        if (x["user_id"].indexOf(this.nameId_DCS) > -1) {
          for (let y of x["workflow"]) {
            if (y["latest_status"] == "Pending Scheduling") {
              this.dcs_pending_scheduling.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            } else if (y["latest_status"] == "Written Test Pending") {
              this.dcs_pending_test_submission.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            } else if (y["latest_status"] == "Phone Interview") {
              this.dcs_phone_interviews.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            } else if (y["latest_status"] == "In-house Interview") {
              this.dcs_inhouse_interviews.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            } else if (y["latest_status"] == "Awaiting Feedback") {
              this.dcs_awaiting_feedback.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            } else if (
              y["latest_status"] == "Selected" ||
              y["latest_status"] == "Start Date"
            ) {
              this.dcs_selected.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                latest_status: y["latest_status"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            } else if (
              y["latest_status"] == "Prospect" ||
              y["latest_status"] == "Urgent Prospect"
            ) {
              this.dcs_prospect.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                latest_status: y["latest_status"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            } else if (
              y["latest_status"] == "Left Message - 1" ||
              y["latest_status"] == "Left Message - 2" ||
              y["latest_status"] == "Left Message - 3"
            ) {
              this.dcs_left_message.push({
                id: x["id"],
                client: y["wf_client"],
                first_name: x["first_name"],
                last_name: x["last_name"],
                latest_status: y["latest_status"],
                notes: y["wf_notes"],
                role_id: this.rolesObj[y["wf_role_id"]],
              });
            }
          }
        }
      } else {
        for (let y of x["workflow"]) {
          if (y["latest_status"] == "Pending Scheduling") {
            this.dcs_pending_scheduling.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          } else if (y["latest_status"] == "Written Test Pending") {
            this.dcs_pending_test_submission.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          } else if (y["latest_status"] == "Phone Interview") {
            this.dcs_phone_interviews.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          } else if (y["latest_status"] == "In-house Interview") {
            this.dcs_inhouse_interviews.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          } else if (y["latest_status"] == "Awaiting Feedback") {
            this.dcs_awaiting_feedback.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          } else if (
            y["latest_status"] == "Selected" ||
            y["latest_status"] == "Start Date"
          ) {
            this.dcs_selected.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              latest_status: y["latest_status"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          } else if (
            y["latest_status"] == "Prospect" ||
            y["latest_status"] == "Urgent Prospect"
          ) {
            this.dcs_prospect.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              latest_status: y["latest_status"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          } else if (
            y["latest_status"] == "Left Message - 1" ||
            y["latest_status"] == "Left Message - 2" ||
            y["latest_status"] == "Left Message - 3"
          ) {
            this.dcs_left_message.push({
              id: x["id"],
              client: y["wf_client"],
              first_name: x["first_name"],
              last_name: x["last_name"],
              latest_status: y["latest_status"],
              notes: y["wf_notes"],
              role_id: this.rolesObj[y["wf_role_id"]],
            });
          }
        }
      }
    }
  }
  detail_toggle(id): void {
  this.show_detail = {
    ...this.show_detail,
    [id]: !this.show_detail[id]
  };
  if (this.show_detail[id]) {
    this.show_role_candidates = {
      ...this.show_role_candidates,
      [id]: false
    };
  }
}

  onBarChartClick({ event, active }: { event: ChartEvent, active: object[] }, roleId: any): void {
    console.log("Bar Chart Click")
    this.detail_toggle(roleId);
  }

  toggle_show_role_candidates(role_id, initialFilter = undefined) {
    console.log("toggle called with:", role_id, initialFilter);
    console.log("current show_role_candidates:", this.show_role_candidates[role_id]);
    const filters = [
      "Urgent Prospect",
      "Recruiter Screen",
      "Resume Submitted",
      "First Interview",
      "Second Interview",
      "Additional Interview",
      "Selected",
      "Started",
    ];
    this.roleCandidatesInitialFilter = filters[initialFilter];
    this.show_role_candidates = {
    ...this.show_role_candidates,
    [role_id]: !this.show_role_candidates[role_id]
  };

  if (this.show_role_candidates[role_id]) {
    this.show_detail = {
      ...this.show_detail,
      [role_id]: false
    };
  }
  }
  changePage(e: any) {
    this.page = e;
    this.updateRolesPipelineTable();
  }
  updateSort(sort: Sort) {
    this.currentSort = sort;
    this.updateRolesPipelineTable();
  }
  sortRoles() {
    const data = this.showRoles.slice();
    if (!this.currentSort.active || this.currentSort.direction === "") {
      this.sortedRoles = data;
      return;
    }

    this.sortedRoles = data.sort((a, b) => {
      const isAsc = this.currentSort.direction === "asc";
      switch (this.currentSort.active) {
        case "priority":
          return compare(a.priority, b.priority, isAsc);
        case "show_pipelines":
          return compare(a.show_pipelines, b.show_pipelines, isAsc);
        case "days_since_open":
          return compare(a.days_since_open, b.days_since_open, isAsc);
        case "practice_group":
          return compare(a.practice_group, b.practice_group, isAsc);
        default:
          return 0;
      }
    });
  }

  ngOnDestroy() {}
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  if (a === b) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
